import { Dispatch, useReducer } from 'react';

import { WorkspaceItem } from '~teacher/hook/workspaces/useWorkspaceItems';

import { assertUnreachable } from '../../../../util/assertUnreachable';

export const enum ActionTypes {
  OPEN = 'open',
  CLOSE = 'close',
}

type MoveWorkspaceItemsDialogAction =
  | { type: 'close' }
  | {
      type: 'open';
      payload: {
        workspaceId: string;
        workspaceItems: WorkspaceItem[];
      };
    };

interface MoveWorkspaceItemsDialogState {
  isOpen: boolean;
  workspaceItems: WorkspaceItem[];
  workspaceId: string;
}

const initialState: MoveWorkspaceItemsDialogState = {
  isOpen: false,
  workspaceItems: [],
  workspaceId: null,
};

function moveWorkspaceItemsReducer(
  state: MoveWorkspaceItemsDialogState,
  action: MoveWorkspaceItemsDialogAction
): MoveWorkspaceItemsDialogState {
  switch (action.type) {
    case ActionTypes.OPEN: {
      const { workspaceId, workspaceItems } = action.payload;
      return {
        workspaceId: workspaceId,
        workspaceItems: workspaceItems,
        isOpen: true,
      };
    }
    case ActionTypes.CLOSE: {
      return {
        workspaceId: null,
        workspaceItems: [],
        isOpen: false,
      };
    }
    default: {
      assertUnreachable(action as never);
    }
  }
}

export type DispatchMoveWorkspaceItemsAction =
  Dispatch<MoveWorkspaceItemsDialogAction>;

export function useMoveWorkspaceItemsDialog(): [
  MoveWorkspaceItemsDialogState,
  DispatchMoveWorkspaceItemsAction
] {
  return useReducer(moveWorkspaceItemsReducer, initialState);
}
